import React from 'react';
import { AsideMenuItem } from './AsideMenuItem';
import { useTranslation } from 'react-i18next';
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub';
import { CLAIMS } from '../../utils/roles-helper';

interface ISubItemProps {
	to: string,
	title?: string,
	isLink?: boolean,
	linkTitle?: string,
	hasBullet?: boolean
}

interface ISubItemsProps {
	path: string,
	title: string,
	isLink?: boolean,
	isForPartner?: boolean,
}

export interface IGetSideMenuItemsProps {
	claim?: CLAIMS,
	path: string,
	title: string,
	icon?: any,
	subMenuItems?: ISubItemsProps[]
}

export const GetSideMenuItems = (props: IGetSideMenuItemsProps): React.ReactElement => {
	const { path, title, icon, subMenuItems } = props;
	const { t } = useTranslation();

	if (subMenuItems) {
		return (
			<AsideMenuItemWithSub
				key={path}
				to={path}
				title={t(title)}
				icon={icon}
			>
				<>
					{
						subMenuItems?.map((subItem: ISubItemsProps) => {
							const props: ISubItemProps = {
								to: subItem.path,
								hasBullet: true
							};
							if (subItem.isLink) {
								props.linkTitle = t(subItem.title);
								props.isLink = true;
								props.hasBullet = false;
							} else {
								props.title = t(subItem.title);
							}

							return <AsideMenuItem key={subItem.path} {...props}/>;
						})
					}
				</>
			</AsideMenuItemWithSub>
		);
	}

	return (
		<AsideMenuItem
			to={path}
			title={t(title)}
			icon={icon}
		/>
	);
};
